import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const Tooltip = ({ children, content }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [showBelow, setShowBelow] = useState(false);
    const triggerRef = useRef(null);

    useEffect(() => {
        if (isVisible && triggerRef.current) {
            const triggerRect = triggerRef.current.getBoundingClientRect();
            
            // Check if we should show tooltip below
            const shouldShowBelow = triggerRect.top < 80;
            setShowBelow(shouldShowBelow);
            
            // Position tooltip above or below the trigger element
            let top = shouldShowBelow 
                ? triggerRect.bottom + 10 
                : triggerRect.top - 10;
            let left = triggerRect.left + (triggerRect.width / 2);
            
            setPosition({ top, left });
        }
    }, [isVisible]);

    // Don't render if no content
    if (!content) return <>{children}</>;

    const tooltipContent = isVisible && createPortal(
        <div
            style={{
                position: 'fixed',
                top: `${position.top}px`,
                left: `${position.left}px`,
                transform: showBelow ? 'translate(-50%, 0)' : 'translate(-50%, -100%)',
                zIndex: 9999,
                backgroundColor: '#1f2937',
                color: 'white',
                padding: '8px 12px',
                borderRadius: '6px',
                fontSize: '12px',
                lineHeight: '1.4',
                maxWidth: '300px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                pointerEvents: 'none',
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }}
        >
            <div>{content}</div>
            {/* Arrow */}
            <div 
                style={{
                    position: 'absolute',
                    width: 0,
                    height: 0,
                    borderLeft: '6px solid transparent',
                    borderRight: '6px solid transparent',
                    [showBelow ? 'borderBottom' : 'borderTop']: '6px solid #1f2937',
                    [showBelow ? 'top' : 'bottom']: '-6px',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }}
            />
        </div>,
        document.body
    );

    return (
        <>
            <span
                ref={triggerRef}
                onMouseEnter={() => {
                    console.log('Tooltip mouseEnter', { content });
                    setIsVisible(true);
                }}
                onMouseLeave={() => {
                    console.log('Tooltip mouseLeave');
                    setIsVisible(false);
                }}
                style={{ display: 'inline-block', cursor: 'help' }}
            >
                {children}
            </span>
            {tooltipContent}
        </>
    );
};

export default Tooltip;
